import { t } from "@/i18n-js/instance";

interface SeeMoreLinkProps {
  onClick: () => void;
}

export const SeeMoreLink = ({ onClick }: SeeMoreLinkProps) => (
  <button
    type="button"
    onClick={onClick}
    className="text-darkest text-sm font-medium"
  >
    {t("help_widget.explore_page.see_more")}
  </button>
);
